module.exports = __webpack_public_path__ + "static/assets/c875993263344a555abd1c669b56a130.gif";